export default {
  'auth/wrong-password': 'Неверный пароль',
  'auth/too-many-requests': 'Поступило много запросов, аккаунт заблокирован' 
}
